var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"application-scene"},[_c('div',{staticClass:"area-title"},[_vm._v("应用场景")]),_c('div',{staticClass:"application-scene-content"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"application-scene-item"},[_c('img',{attrs:{"src":item.img,"alt":""}}),_c('p',[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }